<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <div class="mt-6">
        <v-card elevation="6">
          <div class="pa-4">
            <span style="font-size: 24px">การตั้งราคาพิเศษสำหรับลูกค้าต่อท่าน</span>
          </div>
          <div class="pa-2 grid_4">
            <div></div>
            <div></div>
            <div></div>
            <v-autocomplete color="#8cc63e" @input="addCustomer()" class="autocom_width " :items="customer_list"
                      item-text="name" item-value="id" label="เลือกลูกค้า" v-model="selected" hide-details="auto"
                      required outlined/>
          </div>
          <div class="pa-4">
            <v-data-table :headers="getHeader_list" :items="customerList" :footer-props="footer_Props" mobile-breakpoint="0">
              <template slot="item" slot-scope="dataDetail">
                <tr v-if="!dataDetail.item.is_delete == 1">
                  <td class="mt-3 pa-2">{{ dataDetail.item.customer_name }}</td>
                  <td v-for="(count,index) in (dataDetail.item.condition_lists)" :key="index">
                    <div  class="mt-3 pa-2">
                      <!-- <v-text-field color="#8cc63e" type="number" @keypress="isCurrency($event, count.special_price)" @keyup="sendParameter(count.id, count.set_condition_id, dataDetail.item.customer_id, count.unit_id, count.special_price)" label="ราคา" hide-details="auto" v-model="count.special_price" outlined></v-text-field> -->
                      <v-text-field color="#8cc63e" type="number" @keypress="isCurrency($event, count.special_price)" @keyup="sendParameter()" label="ราคา" hide-details="auto" v-model="count.special_price" outlined></v-text-field>
                    </div>
                  </td>
                  <td class="mt-3 pa-2">
                    <v-btn small height="42" @click="deleteCustomer(dataDetail.item.id,dataDetail.item.create_id)"
                           class="grad-danger-bg white--text mt-2"> 
                      <v-icon>mdi-delete-empty-outline</v-icon> 
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios.js";
import {onlyForCurrency} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Special_Price",
  emits: ['submitSpecialPrice'],
  data() {
    return {
      loading_page: false,
      alert_success: false,
      alert_danger: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      customer: [
        {id: 1, name: 'ลูกค้า 1'},
        {id: 2, name: 'ลูกค้า 2'},
        {id: 3, name: 'ลูกค้า 3'},
        {id: 4, name: 'ลูกค้า 4'},
      ],
      customer_list: [],
      selected: null,
      selected_arr: [],
      input_id: null,
      customerHeader: [
        {
          text: 'ชื่อลูกค้า',
          value: 'customer_name',
        },
        {
          text: 'หน่วยนับที่ 1',
          value: '',
        },
        {
          text: 'หน่วยนับที่ 2',
          value: '',
        },
        {
          text: 'หน่วยนับที่ 3',
          value: '',
        },
        {
          text: 'จัดการ',
          value: '',
        },
      ],
      customerList: [],
      getHeader_list: [],
      getInput_list: [],
      getCondition_list: [],
      productList: [],
      create_id:1,
    }
  },
  methods: {
    /**
     * เรียง condition_lists ให้ตรงกับลำดับหน่วยใน product_list
     * ถ้าไม่มีรายการสำหรับหน่วยนั้น จะใส่ placeholder { unit_id, product_id, customer_id?, special_price: null }
     */
    sortConditionListsByProductList(condition_lists, product_list, customer_id) {
      if (!product_list || product_list.length === 0) return condition_lists || [];
      const list = condition_lists || [];
      return product_list.map((product) => {
        const found = list.find((c) => String(c.unit_id) === String(product.unit_id));
        if (found) return { ...found };
        const placeholder = {
          unit_id: product.unit_id,
          product_id: product.product_id,
          special_price: null,
        };
        if (customer_id != null) placeholder.customer_id = customer_id;
        return placeholder;
      });
    },
    applyConditionListOrder() {
      if (!this.productList || this.productList.length === 0) return;
      const list = Array.isArray(this.customerList) ? this.customerList : [];
      this.customerList = list.map((c) => ({
        ...c,
        condition_lists: this.sortConditionListsByProductList(c.condition_lists, this.productList, c.customer_id),
      }));
    },
    checkLoading() {
      this.getInput_list = []
      const id = this.$route.params.id
      this.loading_page = true
      HTTP.post('/products/productlist/show/' + id)
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
             
              this.productList = res.data.product_list; // เก็บข้อมูล product_list
              this.applyConditionListOrder(); // บังคับเรียง condition_lists ให้ตรงหัวตาราง
              this.getHeader_list = [
                {
                  text: 'ชื่อลูกค้า',
                  value: 'customer_name',
                  sortable: false,
                  fixed: true,
                  width: '250px',
                },
              ];
              res.data.product_list.forEach((details) => {
                this.getHeader_list.push(
                    {
                      text: details.unit_name,
                      value: details.unit_name,
                      sortable: false,
                      fixed: true,
                      width: '200px',
                    }
                )
              })
              this.getHeader_list.push(
                  {
                    text: 'ลบ',
                    value: '',
                    sortable: false,
                    fixed: true,
                    width: '100px',
                  }
              )
              this.getInput_list = res.data.product_list;
            }
          })
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    addCustomer() {
      const product_id = this.$route.params.id;
      const a = this.customer_list.find((details) => details.id === this.selected);

      // ตรวจสอบว่ามีข้อมูล productList หรือไม่
      if (!this.productList || this.productList.length === 0) {
        console.error('Product list is not available');
        return;
      }

      // สร้าง condition_lists จาก productList
      const condition_lists = this.productList.map((data) => ({
        product_id: data.product_id,
        customer_id: a.id,
        unit_id: data.unit_id,
        special_price: null,
      }));

      // เพิ่มข้อมูลลงใน customerList
      this.customerList.push({
        create_id: this.create_id, // ✅
        product_id: product_id,
        customer_name: a.name,
        customer_id: a.id,
        condition_lists: condition_lists,
      });

      // อัปเดตค่าที่เกี่ยวข้อง
      this.create_id++;
      this.selected_arr.push(this.selected);
    },

    // async deleteCustomer(id,createId) {
    //   // await HTTP.post('/setconditioncustomer/delete/' + id )
    //   console.log(createId);
    //   const find_customer = this.customerList.filter(data => data.id == id)
    //   const map_customer = find_customer.map(detail => detail.customer_id)
    //   const pop_id = map_customer.pop()
    //   const index = this.selected_arr.indexOf(pop_id);
    //   if (index > -1) {
    //     this.selected_arr.splice(index, 1);
    //   }
      
    //   if (typeof createId !== 'undefined') {
    //     this.customerList = this.customerList.filter(detail => detail.create_id !== createId)
    //   } else {
    //     this.customerList = this.customerList.map((detail) => {
    //       if(detail.id === id){
    //         return {
    //           ...detail,
    //           is_delete: 1
    //         };
    //       }
    //       return detail
    //     });
    //   }
      
    //        // ✅ เพิ่มบรรทัดนี้เพื่อ Debug
    //   console.log('1. After map in deleteCustomer:', this.customerList);

    //   this.sendParameter()
    //   // this.getCustomer_list();
    //   // this.selected = null;
    //   // this.alert_danger = true;
    //   // setTimeout(() => this.alert_danger = false, 700)
    // },

     async deleteCustomer(id, createId) {
      // สำหรับรายการที่เพิ่งเพิ่มใหม่ (ยังไม่มี id จาก DB)
      if (typeof createId !== 'undefined') {
        this.customerList = this.customerList.filter(detail => detail.create_id !== createId);
      } else {
        // สำหรับรายการที่มีอยู่แล้วใน DB
        // 1. หา index ของรายการที่ต้องการลบ
        const index = this.customerList.findIndex(detail => detail.id === id);

        // 2. ถ้าเจอรายการนั้น ให้ใช้ this.$set เพื่อเพิ่ม is_delete
        if (index > -1) {
          this.$set(this.customerList[index], 'is_delete', 1);
        }
      }

      // ส่วนจัดการ selected_arr (ถ้ายังต้องการ)
      const find_customer = this.customerList.find(data => data.id == id);
      if (find_customer) {
        const pop_id = find_customer.customer_id;
        const selectedIndex = this.selected_arr.indexOf(pop_id);
        if (selectedIndex > -1) {
          this.selected_arr.splice(selectedIndex, 1);
        }
      }

      this.sendParameter();
    },

    getHeader_customer() {
      this.getInput_list = []
      const id = this.$route.params.id
      HTTP.post('/products/productlist/show/' + id)
          .then((res) => {
            if (res.data.success === true) {
              this.getHeader_list = [
                {
                  text: 'ชื่อลูกค้า',
                  value: 'customer_name',
                  sortable: false,
                  fixed: true,
                  width: '250px',
                },
              ];
              res.data.product_list.forEach((details) => {
                this.getHeader_list.push(
                    {
                      text: details.unit_name,
                      value: details.unit_name,
                      sortable: false,
                      fixed: true,
                      width: '200px',
                    }
                )
              })
              this.getHeader_list.push(
                  {
                    text: 'ลบ',
                    value: '',
                    sortable: false,
                    fixed: true,
                    width: '100px',
                  }
              )
              console.log(res.data.product_list)
              this.getInput_list = res.data.product_list;
            }
          })
    },
    sendParameter( ) {
      // sendParameter(id,set_condition_id, customer_id, unit_id, special_price ) {
           // ✅ เพิ่มบรรทัดนี้เพื่อ Debug
      console.log('2. Data before emit:', this.customerList);
      this.$emit('submitSpecialPrice',this.customerList)
      //   if (this.timer) {
      //     clearTimeout(this.timer);
      //     this.timer = null;
      //     this.alert_success = true;
      //   }
      // this.timer = setTimeout(() => {
      //   this.alert_success = false;
      //   HTTP.post('/setconditioncustomer/editsetcondition', {
      //     product_id: this.$route.params.id,
      //     set_condition_id: set_condition_id,
      //     id: id,
      //     customer_id: customer_id,
      //     unit_id: unit_id,
      //     special_price: special_price
      //   })
      // }, 1000);
    },
    get_set_condition() {
      const id = this.$route.params.id;
      HTTP.post('/setconditioncustomer/all', {
        product_id: id
      }).then((res) => {
        if (res.data.success === true){

          this.customerList = res.data.object || [];
          this.applyConditionListOrder(); // บังคับเรียง condition_lists ให้ตรงกับ product_list
          const cus_id = this.customerList.map((detail) => detail.customer_id)
          this.selected_arr = cus_id
          // this.customerList = res.data.object;
          // console.log(this.customerList)
          // this.customerList = res.data.object.map((item, index) => ({
          //   ...item,
          //   create_id: `${index}`, // ✅ เพิ่มให้ทุกอันมี create_id
          // }));
          // const cus_id = this.customerList.map((detail) => {
          //   return detail.customer_id
          // })
          // const cus_id = this.customerList.map((detail) => detail.customer_id)
          // this.selected_arr = cus_id
          // this.getCustomer_list();
        }
      })
    },
    // customer name list
    getCustomer_list() {
      this.customer_list = []
      HTTP.post('/customers/alltrue')
          .then((res) => {
            if (res.data.success === true) {
              res.data.object.forEach((detail) => {
                let inc = this.selected_arr.includes(detail.id)
                if (inc === false) {
                  this.customer_list.push({
                    id: detail.id,
                    name: detail.name_show,
                  })
                }
              })
            }
          })
    },
  },
  beforeMount() {
    this.checkLoading();
  },
  mounted() {
    this.getHeader_customer();
    this.get_set_condition();
    this.getCustomer_list();

  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.autocom_width {
  width: 100%;
}
.grid_4 {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
@media only screen and (max-width: 750px){
  .grid_4 {
    display: grid;
    grid-template-columns: 60% 40%;
  }
}
@media only screen and (max-width: 500px){
  .grid_4 {
    display: grid;
    grid-template-columns: 100%;
  }
}
</style>
